import SharedStateBridge, { useBridgeContext } from '@sendible/shared-state-bridge';
import { useEffect } from 'react';
import { EVENTS, subscribe } from '@sendible/event-manager';
import { loadTranslations } from './i18n';
import { AddProfileModalPrompt, BulkImportUploadBridge, MediaPreview, MediaSystem } from './components';
import XConnection from './components/XConnection';
import BlueskyConnection from './components/BlueskyConnection';
import { useUrlWithCredentials } from './data-layer/useUrlWithCredentials';
import { AiAssistDropdown } from './components/AiAssistDropdown';
import './utils/resizeObserverSuppressor';
import { Portals } from './pages/Portals';
import queryClient from './data-layer/queryClient';
import endpoints from './data-layer/endpoints';

export const FrontendV2Components = () => {
  const [sharedState] = useBridgeContext();

  useEffect(() => {
    loadTranslations(sharedState?.user?.language);
  }, [sharedState?.user?.language]);

  const app = sharedState?.app;

  const isComposeBoxOpen = sharedState?.compose?.isComposeBoxOpen;
  const isNewMediaSystem = sharedState?.compose?.isNewMediaSystem;
  const addThreadsPromptOpenMode = app?.addThreadsPromptOpenMode;
  const addTikTokPromptOpenMode = app?.addTikTokPromptOpenMode;
  const xConnectionModalIsConnect = app?.xConnectionModal.isConnectOpen;
  const xConnectionReconnectionAccountId = app?.xConnectionModal.accountId;
  const blueskyConnectionModalIsConnect = app?.blueskyConnectionModal.isConnectOpen;
  const blueskyConnectionReconnectionAccountId = app?.blueskyConnectionModal.reconnectionAccountId;
  const mediaPreview = app?.mediaPreview;

  const getUrlWithCredentials = useUrlWithCredentials();

  useEffect(() => {
    const cleanQueries = () => {
      queryClient.invalidateQueries({ queryKey: [endpoints.GetTogglableFeatures.endpoint] });
    };

    const unsubscribeTogglableFeatures = subscribe(EVENTS.SWITCH_USER, () => cleanQueries());

    return () => {
      unsubscribeTogglableFeatures();
    };
  }, []);

  return (
    <>
      {app && <Portals />}
      <AiAssistDropdown />
      <BulkImportUploadBridge />
      {addThreadsPromptOpenMode ? (
        <AddProfileModalPrompt
          serviceType="threads"
          mode={addThreadsPromptOpenMode}
        />
      ) : null}
      {addTikTokPromptOpenMode ? (
        <AddProfileModalPrompt
          serviceType="tiktok"
          mode={addTikTokPromptOpenMode}
        />
      ) : null}
      {isComposeBoxOpen && isNewMediaSystem ? <MediaSystem /> : null}
      {xConnectionModalIsConnect ? <XConnection accountId={xConnectionReconnectionAccountId} /> : null}
      {blueskyConnectionModalIsConnect ? <BlueskyConnection getUrlWithCredentials={getUrlWithCredentials} /> : null}
      {blueskyConnectionReconnectionAccountId ? (
        <BlueskyConnection
          getUrlWithCredentials={getUrlWithCredentials}
          accountId={blueskyConnectionReconnectionAccountId}
        />
      ) : null}
      {mediaPreview?.isMediaPreviewOpen ? (
        <MediaPreview
          mediaList={mediaPreview.mediaList}
          initialMediaIndex={mediaPreview.initialMediaIndex}
          onClose={() => {
            SharedStateBridge.updateSpecificKey('app', 'mediaPreview', {
              isMediaPreviewOpen: false,
              mediaList: [],
              initialMediaIndex: 0,
            });
          }}
        />
      ) : null}
    </>
  );
};
